"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function arrayToQueryString(paramArray) {
  const mappedArray = paramArray.map(x => {
    if (x[1]) {
      return [x[0], encodeURIComponent(x[1])].join('=');
    } else {
      return x[0];
    }
  });
  return mappedArray.join('&');
}
exports.default = arrayToQueryString;